import React from 'react'
import { DraggableIcon, LoadingIcon } from '@myxplor/icons'
import './draggable.css'

const isDragable = [
  'only ccms',
  'only ccs'
]

const recordIsDraggable = ({ status }) => isDragable.includes(status)

const DragHandle = ({ record, selected = false, merging = false }) => (
  !selected && recordIsDraggable(record) &&
  (
    <div className="dragHandle">
      {
        merging ?
          <LoadingIcon isLoading /> :
          <DraggableIcon className="dragIcon" />
      }
    </div>

  )
)

export {
  recordIsDraggable,
  DragHandle
}



// WEBPACK FOOTER //
// ./src/care-enrolments/list-item/draggable.jsx